import {CompleteNotification, ErrorNotification, NextNotification} from 'rxjs'

export const nextNotification = <T>(value: T): NextNotification<T> => ({kind: 'N', value})
export const errorNotification = (error: any): ErrorNotification => ({kind: 'E', error})
export const completeNotification = (): CompleteNotification => ({kind: 'C'})